import { head, last } from 'ramda';
import React from 'react';
import { formatPrice, numberPercent } from '../../../../utils';
import { ChartData } from '../../entities';
import { ChartRangeWrapper } from './styles';

const formatNumber = (value: number, percentage = false) => {
  const rounded = percentage ? numberPercent(value, false) : formatPrice(value);

  // numberPercent already adds the `-`, we just also want to add the `+`
  const signPrefix = value > 0 ? '+' : '';
  return `${signPrefix}${rounded}`;
};

interface Props {
  data: ChartData[];
}

const PriceRange = ({ data }: Props) => {
  const firstDataPointOfPeriod = head(data);
  const lastDataPointOfPeriod = last(data);

  if (!firstDataPointOfPeriod || !lastDataPointOfPeriod) {
    return null;
  }

  const changeNominal = lastDataPointOfPeriod.close - firstDataPointOfPeriod.open;
  const changePercent = (changeNominal / lastDataPointOfPeriod.open) * 100;

  return (
    <ChartRangeWrapper $sign={Math.sign(changeNominal)}>
      {formatNumber(changeNominal)} [{formatNumber(changePercent, true)}]
    </ChartRangeWrapper>
  );
};

export default PriceRange;
